import store from './store';
import WelcomeScreen from './views/welcomeScreen.vue';

const routes = [
 // {
 //    path: '/signup',
 //    name: 'signup',
 //    component: () => import('./views/signup.vue')
 //  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('./views/signin.vue')
  },
  {
    path: '/generatePassword',
    name: 'generatePassword',
    component: () => import('./views/resetpassword.vue')
  },
  {
    path: '/verifyotp',
    name: 'verifyotp',
    component: () => import('./views/otp.vue')
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: WelcomeScreen
  },
  {
    path: '/',
    redirect: '/welcome',
    name: 'home',
    component: WelcomeScreen
  },
  {
    path: "/paylief-ess",
    name: "paylief-ess",
    component: () => import('./views/dwsPaylief.vue')
  },
  {
    path: "/restricted",
    name: "restricted",
    component: () => import('./views/accessDenied.vue')
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: () => import('./views/accessDenied.vue')
  }
];

export default {
  routes,
  store,
};
